<template lang='pug'>
  v-layout(class='wrapper' row wrap)
    main-banner
    v-flex(xs12 sm6 offset-sm3)
      v-card(class="my-2 mx-4")
        v-card-text
          div(v-if="missingUsername"
            class="red--text") Email cannot be empty
          v-text-field(class="form-field"
            label="Email"
            id="username"
            v-model="username"
            @keyup.enter="sendPasswordCode"
            :hint="'Note that this field is case-sensitive.'")
          v-btn(class="mx-0 secondary full-width login-button"
            @click="sendPasswordCode"
            id="forgot-password-button") Submit
</template>

<script>
  import MainBanner from 'Components/MainBanner.vue'
  import { mapActions } from 'vuex'

  export default {
    name: 'forgot-password',
    components: {
      MainBanner
    },
    data () {
      return {
        username: '',
        missingUsername: false,
      }
    },
    methods: {
      ...mapActions([
        'forgotPassword',
        'updateChangePasswordData'
      ]),
      sendPasswordCode () {
        const { username } = this

        if (username === '') {
          this.missingUsername = true
        } else {
          this.missingUsername = false
          this.storeUserData(username)
          this.forgotPassword({ username })
          this.$router.push({ path: '/forgot-password-change' })
        }
      },
      storeUserData (username) {
        this.updateChangePasswordData({
          username,
          oldPassword: ''
        })
      }
    }
  }
</script>
<style scoped>
.v-text-field::v-deep .v-messages__message {
  color: #4b91e3;
}
.wrapper{
  height: 100%;
  background-color: #4b91e3
}
</style>
